import React, { createContext, useContext, useState, useEffect } from 'react';

const OrderContext = createContext(undefined);

export function OrderProvider({ children }) {
    const [activeOrder, setActiveOrder] = useState(null);

    // Load from localStorage on mount
    useEffect(() => {
        const savedOrder = localStorage.getItem('tcr_active_order');
        if (savedOrder) {
            try {
                const parsed = JSON.parse(savedOrder);
                // If it was delivered more than an hour ago, don't show it as active
                if (parsed.status === 'delivered') {
                    setActiveOrder(null);
                    return;
                }
                setActiveOrder(parsed);
            } catch (e) {
                console.error('Failed to parse active order', e);
            }
        }
    }, []);

    // Sync to localStorage
    useEffect(() => {
        if (activeOrder) {
            localStorage.setItem('tcr_active_order', JSON.stringify(activeOrder));
        } else {
            localStorage.removeItem('tcr_active_order');
        }
    }, [activeOrder]);

    const updateOrderStatus = (status) => {
        if (activeOrder) {
            setActiveOrder({ ...activeOrder, status });
        }
    };

    return (
        <OrderContext.Provider value={{ activeOrder, setActiveOrder, updateOrderStatus }}>
            {children}
        </OrderContext.Provider>
    );
}

export function useOrder() {
    const context = useContext(OrderContext);
    if (context === undefined) {
        throw new Error('useOrder must be used within an OrderProvider');
    }
    return context;
}
